export const SearchHighLight = (rawText: string, searchText: string): string => {
	const stkName: string = rawText.toLowerCase();

	let rawTextTemp: string =
		stkName.indexOf(searchText) >= 0
			? rawText.substring(0, stkName.indexOf(searchText)) +
			  "<b>" +
			  rawText.substring(stkName.indexOf(searchText), stkName.indexOf(searchText) + searchText.length) +
			  "</b>" +
			  rawText.substring(stkName.indexOf(searchText) + searchText.length, rawText.length)
			: rawText;

	return rawTextTemp;
};
